"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const Navigation_1 = __importDefault(require("../ShoppingCart/Navigation"));
const AccountBalance_1 = __importDefault(require("./AccountBalance"));
const BalanceDetails_1 = __importDefault(require("./BalanceDetails"));
const CreditCardPayment_1 = __importDefault(require("./CreditCardPayment"));
const StatusScreen_1 = __importDefault(require("./StatusScreen"));
const KioskAppHeader_1 = __importDefault(require("../Header/KioskAppHeader"));
const OnlineCheckinFlow_1 = require("./OnlineCheckinFlow");
const Wrapper = styled_components_1.default.div `
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1102;
  background: #fff;
  height: 100%;
  width: 100%;
  overflow: auto;
`;
const ContentWrapper = styled_components_1.default.div `
  max-width: 520px;
  margin-top: 56px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 600px) {
    margin-top: 64px;
  }
`;
const dialogTypes = {
    checkinDataProcessing: {
        text: 'Thank you for your patience. Your data is being processed.',
        showProgress: true,
        actionText: 'Cancel',
    },
    serverError: {
        title: null,
        text: i18n_js_1.default.t('unknown_error_message'),
        actionText: i18n_js_1.default.t('cancel'),
        showProgress: false,
    },
};
const Transition = react_1.default.forwardRef((props, ref) => {
    return react_1.default.createElement(material_1.Slide, Object.assign({ direction: "up", ref: ref }, props));
});
const OnlineCheckoutFlow = ({ baseUrl, history, currentLocale, userData, kioskModeEnabled }) => {
    const [displayStep, setDisplayStep] = (0, react_1.useState)(OnlineCheckinFlow_1.STAY_FORM_SCREEN);
    const [dialogIsOpen, setDialogOpen] = (0, react_1.useState)(false);
    const [dialogData, setDialogData] = (0, react_1.useState)(dialogTypes.serverError);
    const [headerText, setHeaderText] = (0, react_1.useState)(i18n_js_1.default.t('api_guest_journey_checkout_title'));
    const [balanceData, setBalanceData] = (0, react_1.useState)(null);
    const [creditCardData, setCreditCardData] = (0, react_1.useState)(null);
    const [adyenData, setAdyenData] = (0, react_1.useState)({});
    const [statusData, setStatusData] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => () => {
        const storedPaymentReference = localStorage.getItem('paymentReference');
        const token = kioskModeEnabled ? localStorage.getItem('kioskUserToken') : userData.token;
        const stationToken = localStorage.getItem('stationToken');
        if (storedPaymentReference) {
            apiService_1.default.cancelPaymentSesison(currentLocale, token, storedPaymentReference, kioskModeEnabled, stationToken);
            localStorage.setItem('paymentReference', '');
        }
    }, []);
    const [showDiscardFormDialog, setShowDiscardFormDialog] = (0, react_1.useState)(false);
    let pageToDisplay = react_1.default.createElement("div", null, "step1");
    if (displayStep === OnlineCheckinFlow_1.STAY_FORM_SCREEN) {
        pageToDisplay = (react_1.default.createElement(AccountBalance_1.default, { fromCheckoutFlow: true, setDisplayStep: setDisplayStep, balanceData: balanceData, setBalanceData: setBalanceData, openBalanceDetails: () => {
                setDisplayStep(OnlineCheckinFlow_1.CREDIT_CARD_PAYMENT_SCREEN);
            }, setDialogData: setDialogData, openDialog: () => {
                setDialogOpen(true);
                setDialogData(dialogTypes.checkinDataProcessing);
            }, closeDialog: () => {
                setDialogOpen(false);
            }, setCreditCardData: setCreditCardData, setHeaderText: setHeaderText, openSpecificErrorDialog: message => {
                setDialogOpen(true);
                setDialogData({
                    text: message,
                    actionText: i18n_js_1.default.t('cancel'),
                    showProgress: false,
                });
            }, openErrorDialog: () => {
                setDialogOpen(true);
                setDialogData(dialogTypes.serverError);
            }, setStatusData: setStatusData }));
    }
    if (displayStep === OnlineCheckinFlow_1.INVOICE_SCREEN) {
        pageToDisplay = (react_1.default.createElement(CreditCardPayment_1.default, { fromCheckoutFlow: true, creditCardData: creditCardData, setDisplayStep: setDisplayStep, setAdyenData: data => {
                localStorage.setItem('paymentReference', data.reference);
                setAdyenData(data);
            }, adyenData: adyenData, openDialog: () => {
                setDialogOpen(true);
                setDialogData(dialogTypes.checkinDataProcessing);
            }, closeDialog: () => {
                setDialogOpen(false);
            }, openErrorDialog: () => {
                setDialogOpen(true);
                setDialogData(dialogTypes.serverError);
            }, setDialogData: setDialogData, setStatusData: setStatusData, setHeaderText: setHeaderText, onPaymentFailure: data => {
                setStatusData(data);
                setDisplayStep(OnlineCheckinFlow_1.STATUS_SCREEN);
            } }));
    }
    if (displayStep === OnlineCheckinFlow_1.CREDIT_CARD_PAYMENT_SCREEN) {
        pageToDisplay = react_1.default.createElement(BalanceDetails_1.default, { balanceData: balanceData });
    }
    if (displayStep === OnlineCheckinFlow_1.STATUS_SCREEN) {
        pageToDisplay = react_1.default.createElement(StatusScreen_1.default, { statusData: statusData });
    }
    const navIcon = displayStep === OnlineCheckinFlow_1.CREDIT_CARD_PAYMENT_SCREEN ? 'arrow_back' : 'close';
    const handleCheckoutDiscard = (action = '') => {
        if (action === 'confirm') {
            if (kioskModeEnabled) {
                history.push(`${baseUrl}/guest_journey/kiosk`);
                return;
            }
            history.push(`${baseUrl}`);
        }
        else {
            setShowDiscardFormDialog(false);
        }
    };
    const navAction = () => {
        if (displayStep === OnlineCheckinFlow_1.CREDIT_CARD_PAYMENT_SCREEN) {
            setDisplayStep(OnlineCheckinFlow_1.STAY_FORM_SCREEN);
        }
        else if (displayStep === OnlineCheckinFlow_1.INVOICE_SCREEN) {
            setShowDiscardFormDialog(true);
        }
        else {
            history.push(`${baseUrl}`);
        }
    };
    const kioskNavAction = () => {
        if (displayStep === OnlineCheckinFlow_1.CREDIT_CARD_PAYMENT_SCREEN) {
            setDisplayStep(OnlineCheckinFlow_1.STAY_FORM_SCREEN);
        }
        else if (displayStep === OnlineCheckinFlow_1.STATUS_SCREEN) {
            history.push(`${baseUrl}/guest_journey/kiosk`);
        }
        else {
            setShowDiscardFormDialog(true);
        }
    };
    return (react_1.default.createElement(Wrapper, null,
        !kioskModeEnabled && react_1.default.createElement(KioskAppHeader_1.default, { title: headerText, navAction: kioskNavAction }),
        react_1.default.createElement(Navigation_1.default, { icon: navIcon, onClick: navAction, headline: headerText }),
        kioskModeEnabled && react_1.default.createElement(KioskAppHeader_1.default, { title: headerText, navAction: kioskNavAction }),
        react_1.default.createElement(ContentWrapper, null, pageToDisplay),
        react_1.default.createElement(material_1.Dialog, { open: dialogIsOpen },
            dialogData.title && react_1.default.createElement(material_1.DialogTitle, { id: "alert-dialog-title" }, dialogData.title),
            react_1.default.createElement(material_1.DialogContent, null,
                dialogData.text,
                dialogData.showProgress && react_1.default.createElement(material_1.LinearProgress, null)),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { onClick: () => {
                        setDialogOpen(false);
                        if (kioskModeEnabled) {
                            history.push(`${baseUrl}/guest_journey/kiosk`);
                            return;
                        }
                        history.replace(`${baseUrl}`);
                    } }, dialogData.actionText))),
        react_1.default.createElement(material_1.Dialog, { "data-testid": "discard-form", open: showDiscardFormDialog, TransitionComponent: Transition, keepMounted: true, onClose: () => handleCheckoutDiscard(), "aria-describedby": "alert-dialog-slide-description" },
            react_1.default.createElement(material_1.DialogTitle, null, i18n_js_1.default.t('dismiss_registration_title')),
            react_1.default.createElement(material_1.DialogContent, null, i18n_js_1.default.t('dismiss_registration_text')),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { onClick: () => handleCheckoutDiscard() }, i18n_js_1.default.t('continue_editing_button')),
                react_1.default.createElement(material_1.Button, { "data-testid": "confirm-discard", onClick: () => handleCheckoutDiscard('confirm') }, i18n_js_1.default.t('dismiss_button'))))));
};
const mapStoreToProps = store => ({
    baseUrl: store.getValue('baseUrl'),
    currentLocale: store.getValue('currentLocale'),
    userData: store.getValue('userData'),
    kioskModeEnabled: store.getValue('kioskModeEnabled'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(OnlineCheckoutFlow));
